import { Box, SxProps, Theme } from "@mui/material";
import * as React from "react";
import { PhoneCallingIcon } from "../icons/PhoneCallingIcon";
import Link from "next/link";

const CallNowButton: React.FC<{ sx?: SxProps<Theme> }> = ({ sx }) => {
  return (
    <Link href="tel:+442081253546" aria-label="Call us now on 020 8125 3546">
      <Box sx={{ position: "relative", minWidth: "174px", ...sx }}>
        <Box sx={{ position: "relative", zIndex: 3 }}>
          <Box
            sx={{
              border: "4px solid #5D04D9",
              bgcolor: "#fff",
              borderRadius: "50%",
              width: "45px",
              height: "45px",
              display: "grid",
              placeItems: "center",
              svg: {
                width: "22px",
                height: "22px",
                color: "#5D04D9",
              },
            }}
          >
            <PhoneCallingIcon />
          </Box>
        </Box>

        <Box
          sx={{
            position: "absolute",
            zIndex: 1,
            top: "-6.5px",
            left: "-7px",
            bgcolor: "#fff",
            border: "3px solid #C1BEFF",
            borderRadius: "50%",
            width: "58px",
            height: "58px",
          }}
        ></Box>

        <Box
          sx={{
            position: "absolute",
            zIndex: 2,
            top: "8px",
            left: "32px",
            p: "7px 10px 6px 15px",
            color: "#fff",
            fontSize: { xs: "14px", md: "1rem" },
            fontWeight: 600,
            fontFamily: "'blauerNue', 'blauerNue Fallback'",
            background: "linear-gradient(90deg, rgba(2,0,67,1) 0%, rgba(6,0,169,1) 85%)",
            minWidth: "138px",
            borderRadius: "0px 4px 12px 0px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              position: "absolute",
              top: "-16px",
              gap: "6px",
            }}
          >
            <Box sx={{ fontSize: "12px", color: "#060273" }}>Call us now</Box>
            <Box sx={{ width: "50px", height: "3px", bgcolor: "#C1BEFF" }}></Box>
          </Box>
          <Box sx={{ position: "relative" }}>020 8125 3546</Box>
        </Box>
      </Box>
    </Link>
  );
};

export default CallNowButton;
